<div class="dialog">
    <div class="dialog-header">
        <h2>{{ 'coupons.dialog.publication-date.heading' | translate }}</h2>
    </div>
    <div class="dialog-body">
        <form class="left">
            <div class="form-radios">
                <div class="form-row">
                    <label>
                        <input type="radio"
                            checked
                            name="choice"
                            value="ASAP"
                            [(ngModel)]="model.choice">
                        {{ 'coupons.dialog.publication-date.choice-1' | translate }}
                    </label>
                </div>

                <div class="form-row">
                    <label>
                        <input type="radio"
                            name="choice"
                            value="DATE"
                            [(ngModel)]="model.choice">
                        {{ 'coupons.dialog.publication-date.choice-2' | translate }}
                    </label>
                </div>
            </div>

            <div class="form-row">
                <div class="widget-datetime">
                    <app-form-datepicker
                        name="date"
                        [resetable]="false"
                        [min]="getDateMin()"
                        [max]="getDateMax()"
                        [disabled]="model.choice === 'ASAP'"
                        [(ngModel)]="model.date">
                    </app-form-datepicker>

                    <select
                        required
                        name="time"
                        [disabled]="model.choice === 'ASAP'"
                        [(ngModel)]="model.time">
                        <option *ngFor="let hour of hours" value="{{ hour }}">{{ hour }}</option>
                    </select>
                </div>

                <div class="form-hint">
                    {{ 'shared.timezone' | translate }}
                </div>
            </div>

        </form>

        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" (click)="onConfirm()">{{ 'shared.button.confirm' | translate }}</a>
        </div>
    </div>
</div>
